export const COLORS = {
	primary: '#008fb3', // $colorCornflowerBlue
	primaryContrast: '#fff',
	secondary: '#f1f1f1',
	secondaryContent: '#fff',
	footer: '#e1e1e1',
	footerContrast: '#fff',
};

const gridBase = 20;

export const GRID = {
	'1': gridBase,
	'2': gridBase * 2,
	'3': gridBase * 3,
	'4': gridBase * 4,
	'5': gridBase * 6,
};

export const FONT_SIZES = {
	'1': '16px;',
	'2': '24px',
	'3': '36px',
	'4': '52px',
	'5': '76px',
	'6': '101px',
};

export const FONT_FAMILES = {
	primary: '\'Open Sans\', sans-serif;',
	secondary: '\'Indie Flower\', cursive;',
};

export const BREAKPOINTS = {
	small: 0,
	medium: 737,
	large: 1025,
};

export const CONTAINERS = {
	medium: 820,
	large: 910,
};

export const MELOGO = {
	small: 280,
	medium: 330,
	borderSmall: 5,
	borderMedium: 8,
};



// WEBPACK FOOTER //
// ./src/styles.js